import { format } from 'date-fns'

const DATE_FORMAT = 'do MMMM yyyy'

export const date = (input: Date): string => {
  return format(input, DATE_FORMAT)
}
